/**
 * @import { PortInfo } from '@/features/itinerary-map/types/port-info'
 */

import { useState } from 'react';
import { PortInfoContext } from '../context/port-info';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */

export const PortInfoProvider = ({ children }) => {
  const [portInfo, setPortInfo] = useState(/** @type {PortInfo | null} */ (null));

  return <PortInfoContext.Provider value={{ portInfo, setPortInfo }}>{children}</PortInfoContext.Provider>;
};
